import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mp-checkbox',
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './mp-checkbox.component.html',
  styleUrls: ['./mp-checkbox.component.scss']
})
export class MpCheckboxComponent implements OnInit {

  @ContentChild(TemplateRef, { static: false }) labelTemplate!: TemplateRef<any>;

  @Input() public size: 'small' | 'medium' | 'large' = 'large';
  @Input() public value: boolean;
  @Input() public label: string;
  @Input() public formControl: FormControl;
  @Input() public disabled: boolean;
  @Input() public checked: boolean;
  @Input() public notCheckedType: 'empty' | 'outlined' = 'empty';
  @Input() public color: 'primary' | 'accent' = 'primary';
  @Input() public id: string = 'checkbox-css-id';

  @Output() public valueChange = new EventEmitter<boolean>();

  ngOnInit() {
    if (this.formControl) {
      this.value = this.formControl.value;
    }
  }

  public changeValue() {
    if (!this.disabled) {
      this.value = !this.value;
      this.checked = this.value;
      if (this.formControl) {
        this.formControl.setValue(this.value);
      }
      this.valueChange.emit(this.value);
    }
  }
}
